package com.artvending.warden

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.artvending.warden.screens.home.HomeScreenModel
import com.artvending.warden.screens.sending.SendingScreenModel
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.*
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonObject
import kotlin.math.abs
import kotlin.random.Random

expect val isWebVersion: Boolean
expect val commonSettings: MySettings
expect val db: Db
var lastCheckAllowDeviceTime: LocalDateTime? = null
var userPikalkaId by mutableStateOf("_")
var userId = 0
var deviceId = 1
var workingCalendarId = 1
var avatar by mutableStateOf("")
var errorMessage by mutableStateOf("")
var errorMessageId = 0
var language: Language = RusLanguage()
var thisMonthHistoryUnits: List<HistoryUnit>? by mutableStateOf(null)
var isGeolocationGetting by mutableStateOf(false)
var test = 0
var allowDevice: Boolean? by mutableStateOf(null)

val today
	get() = LocalDate.now()

var currentPage by mutableStateOf(Page.HOME)
var pickTime by mutableStateOf<LocalDateTime?>(null)
var isSending = false
var scanCount = 0
expect val httpClient: HttpClient
expect val dialog: Dialog
expect val geolocation: GeolocationManager
expect val sendingQueue: SendingQueue

val remarks: List<Pair<LocalDate, Int?>>
	get() {
		val list = ArrayList<Pair<LocalDate, Int?>>()
		
		val thisMonthHistoryUnits = thisMonthHistoryUnits
		
		if (thisMonthHistoryUnits == null)
			return emptyList()
		
		for (unit in thisMonthHistoryUnits) {
			val late = unit.getLate(thisMonthHistoryUnits)
			val earlyEnd = unit.getEarlyEnd(thisMonthHistoryUnits)
			
			if (late > 0)
				list.add(unit.date to late)
			
			if (earlyEnd > 0)
				list.add(unit.date to -earlyEnd)
		}
		
		return list
	}

val todayWorkingTime: TimeInterval?
	get() {
		val todayUnit = thisMonthHistoryUnits?.firstOrNull { it.date == today && it.mode == HistoryUnitMode.FIXED_WORKING_TIME }
		
		return TimeInterval(todayUnit?.workingTimeFrom, todayUnit?.workingTimeTo)
	}

var fixedInterval: TimeInterval?
	get() {
		val todayUnit = thisMonthHistoryUnits?.firstOrNull { it.date == today && it.mode == HistoryUnitMode.FIXED_WORKING_TIME }
		val from = todayUnit?.fixedFrom
		val to = todayUnit?.fixedTo
		
		return TimeInterval(from, if (from != null && to != null && to - from < 1) null else to)
	}
	set(value) {
		val tmhu = ArrayList(thisMonthHistoryUnits ?: emptyList())
		val todayUnit = tmhu.first { it.date == today && it.mode == HistoryUnitMode.FIXED_WORKING_TIME }
		val index = tmhu.indexOf(todayUnit)
		
		tmhu[index] = HistoryUnit(
			todayUnit.date,
			todayUnit.workingTimeFrom,
			todayUnit.workingTimeTo,
			value?.from,
			value?.to,
			todayUnit.mode
		)
		
		thisMonthHistoryUnits = tmhu
	}

private var _currentScreenModel by mutableStateOf<ScreenModel?>(null)

var currentScreenModel
	get() = _currentScreenModel
	set(value) {
		if (_currentScreenModel != value) {
			_currentScreenModel?.exit()
			_currentScreenModel = value
			
			val page = value?.page
			
			if (page != null)
				currentPage = page
			
			_currentScreenModel?.enter()
		}
	}


fun LocalDateTime.Companion.now() = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())


fun LocalDate.Companion.now() = LocalDateTime.now().date


fun LocalDateTime.getDayMinutes() = hour * 60 + minute


fun getDayOfWeekStr(dayOfWeek: Int) = when (dayOfWeek) {
	0 -> language.MONDAY
	1 -> language.TUESDAY
	2 -> language.WEDNESDAY
	3 -> language.THURSDAY
	4 -> language.FRIDAY
	5 -> language.SATURDAY
	6 -> language.SUNDAY
	else -> throw IllegalArgumentException("Invalid day of week")
}


fun getDayOfWeekStr(dayOfWeek: DayOfWeek) = getDayOfWeekStr(dayOfWeek.ordinal)


fun getMonthStr2(monthNumber: Int) = when (monthNumber) {
	1 -> language.JANUARY_2
	2 -> language.FEBRUARY_2
	3 -> language.MARCH_2
	4 -> language.APRIL_2
	5 -> language.MAY_2
	6 -> language.JUNE_2
	7 -> language.JULY_2
	8 -> language.AUGUST_2
	9 -> language.SEPTEMBER_2
	10 -> language.OCTOBER_2
	11 -> language.NOVEMBER_2
	12 -> language.DECEMBER_2
	else -> throw IllegalArgumentException("Invalid month")
}


fun Month.toMyString2() = getMonthStr2(number)


@OptIn(DelicateCoroutinesApi::class)
fun launch(block: suspend () -> Unit) {
	GlobalScope.launch { block() }
}


fun log(message: Any?) {
	if (commonSettings.DEBUG_MODE)
		println(message)
}


fun getTodayInfo() {
	launch {
		thisMonthHistoryUnits = loadMonth(today.year, today.month.number)
		(currentScreenModel as? HomeScreenModel)?.dateTimeUserData = DateTimeUserData.get()
	}
}


suspend fun checkDevicePermission() {
	var answer: String? = null
	
	while (answer == null) {
		if (isInternetAvailable()) {
			lastCheckAllowDeviceTime = LocalDateTime.now()
			
			answer = try {
				webHook("user.get", "id" to userId)
			} catch (e: Exception) {
				if (isInternetAvailable())
					er("Check device permission error!", e.message)
				else
					er(language.OFFLINE_ERROR)
				
				null
			}
		}
		
		if (answer == null)
			delay(3000)
	}
	
	val json = Json.parseToJsonElement(answer).jsonObject
	val result = json["result"]!!.jsonArray[0].jsonObject
	val allowDeviceIds = result["UF_USR_ALLOW_WARDEN_DEVICE_ID"].toString().replace("\"", "").trim('[').trim(']').split(',').map { it.trim().toIntOrNull() }.filter { it != null }
	
	allowDevice = if (deviceId in allowDeviceIds)
		true
	else {
		if (!isWebVersion)
			showMessageAndWait(language.WARNING, language.DEVICE_NOT_ALLOWED)
		
		false
	}
}


suspend fun checkIfNeed() {
	if ((LocalDateTime.now().toEpocTime() - (lastCheckAllowDeviceTime?.toEpocTime() ?: 0)) > 5000 * 60)
		checkDevicePermission()
}


suspend fun loadMonth(year: Int, monthNumber: Int): List<HistoryUnit> {
	val historyUnits = ArrayList<HistoryUnit>()
	
	fun getFullMinutes(str: String): Int? {
		val str = str.trim()
		val indexOfSpace = str.indexOf(" ")
		
		if (indexOfSpace == -1)
			return null
		
		val parts = str.substring(indexOfSpace + 1).split(":")
		
		if (parts.size != 3)
			return null
		
		return parts[0].toInt() * 60 + parts[1].toInt()
	}
	
	val monthStr = monthNumber.toString().padStart(2, '0')
	var answerStr: String? = null
	
	while (answerStr == null) {
		if (isInternetAvailable()) {
			answerStr =
				try {
					httpClient.multiSendGetRequest(
						if (commonSettings.DEBUG_MODE)
						//"https://dev24.art-vending.online/rest/3/pd7awms6qnmnwz5g/worktime.user.get?time_control_code=$userPikalkaId&date=${monthStr}.$year"
							"https://dev24.art-vending.online/rest/22/g2100sb8uvjaukfy/worktime.user.get?time_control_code=$userPikalkaId&date=${monthStr}.$year"
						else
							//"https://b24.art-vending.online/rest/22/g2100sb8uvjaukfy/worktime.user.get?time_control_code=$userPikalkaId&date=${monthStr}.$year"
						"https://b24.art-vending.online/rest/3/pd7awms6qnmnwz5g/worktime.user.get?time_control_code=$userPikalkaId&date=${monthStr}.$year"
					)
				} catch (e: Exception) {
					if (isInternetAvailable())
						er("Load month info error!", e.message)
					else
						er(language.OFFLINE_ERROR)
					
					null
				}
		}
		
		if (answerStr == null)
			delay(3000)
	}
	
	val answerJson = Json.parseToJsonElement(answerStr).jsonObject
	val isError = answerJson["error"] != null
	
	if (isError)
		return emptyList()
	
	val resultJson = answerJson["result"]!!.jsonObject
	val datesDataJson = resultJson["dates_data"]!!.jsonArray
	
	datesDataJson.forEach {
		try {
			val json = it.jsonObject
			
			val dateStartStr = json["date_start"].toString().replace("\"", "")
			val dateFinishStr = json["date_finish"].toString().replace("\"", "")
			val schedule = json["schedule"]!!.jsonObject
			val calendarStartStr = schedule["max_exact_start"].toString().replace("\"", "")
			val calendarEndStr = schedule["min_exact_end"].toString().replace("\"", "")
			
			val dayOfMonth = dateStartStr.substring(0, 2).toInt()
			val calendarStartSeconds = calendarStartStr.toIntOrNull()
			val calendarEndSeconds = calendarEndStr.toIntOrNull()
			
			val date = try {
				LocalDate(year, monthNumber, dayOfMonth)
			} catch (e: Exception) {
				null
			}
			
			if (date != null)
				historyUnits += HistoryUnit(
					date,
					if (calendarStartSeconds == null) null else calendarStartSeconds / 60,
					if (calendarEndSeconds == null) null else calendarEndSeconds / 60,
					getFullMinutes(dateStartStr),
					getFullMinutes(dateFinishStr),
					HistoryUnitMode.FIXED_WORKING_TIME
				)
		} catch (e: Exception) {
			er(e.message)
		}
	}
	
	val absencesJson = resultJson["absences"]!!.jsonArray
	
	fun stringToDateTime(dateOrDateTime: String): LocalDateTime {
		var dateStr = ""
		var timeStr = ""
		
		if (dateOrDateTime.contains(" ")) {
			val parts = dateOrDateTime.split(' ')
			dateStr = parts[0]
			timeStr = parts[1]
		}
		else {
			dateStr = dateOrDateTime
		}
		
		val dateParts = dateStr.split('.')
		val date = LocalDateTime(dateParts[2].toInt(), dateParts[1].toInt(), dateParts[0].toInt(), 0, 0, 0, 0)
		
		
		if (timeStr == "")
			return date
		else {
			val timeParts = timeStr.split(":")
			return LocalDateTime(date.year, date.month, date.dayOfMonth, timeParts[0].toInt(), timeParts[1].toInt(), timeParts[2].toInt())
		}
	}
	
	absencesJson.forEach {
		val json = it.jsonObject
		val fromStr = json["from"].toString().replace("\"", "")
		val toStr = json["to"].toString().replace("\"", "")
		val typeStr = json["type"].toString().replace("\"", "")
		
		val from = stringToDateTime(fromStr)
		val to = stringToDateTime(toStr)
		
		val mode = when (typeStr) {
			"Отпуск" -> HistoryUnitMode.VACATION
			"Командировка" -> HistoryUnitMode.BUSINESS_TRIP
			"Больничный" -> HistoryUnitMode.SICK_LEAVE
			"Отпуск декретный" -> HistoryUnitMode.MATERNITY_LEAVE
			"Работает удаленно" -> HistoryUnitMode.REMOTE_WORK
			"Дежурство на Заходней" -> HistoryUnitMode.DUTY_ON_ZAHODNIA
			"Отгул за свой счет" -> HistoryUnitMode.OUT_OF_POCKET_TIME_OFF
			"На объекте" -> HistoryUnitMode.ON_OBJECT
			"Работа в выходной" -> HistoryUnitMode.WEEKEND_WORK
			"Отпросился по уважительной причине (отсутствие до 3 часов)" -> HistoryUnitMode.ABSENCE_TO_3_HOURS
			"Отпросился по уважительно причине больше 3-х часов" -> HistoryUnitMode.ABSENCE_MORE_3_HOURS
			"Отпросился без уважительной причины" -> HistoryUnitMode.UNEXCUSED_ABSENCE
			"Прогул" -> HistoryUnitMode.TRUANCY
			"Другое" -> HistoryUnitMode.OTHER
			else -> HistoryUnitMode.UNKNOWN
		}
		
		if (to >= from) {
			val dateFrom = from.date
			val dateTo = to.date
			var date = dateFrom
			
			while (true) {
				val _from = if (date == dateFrom) from.getDayMinutes() else null
				val _to = if (date == dateTo) to.getDayMinutes() else null
				
				historyUnits += HistoryUnit(
					date,
					null,
					null,
					if (_from == 0) null else _from,
					if (_to == 0) null else _to,
					mode
				)
				
				if (date >= dateTo)
					break
				
				date = date.plus(1, DateTimeUnit.DAY)
			}
		}
		
	}
	
	if (year == today.year && monthNumber == today.month.number) {
		val todayUnit = historyUnits.firstOrNull { it.date == today }
		
		if (todayUnit == null) {
			var answer: String? = null
			
			while (answer == null) {
				if (isInternetAvailable()) {
					answer = try {
						webHook("timeman.schedule.get", "id" to workingCalendarId)
					} catch (e: Exception) {
						if (isInternetAvailable())
							er("Load schedule info error!", e.message)
						else
							er(language.OFFLINE_ERROR)
						
						null
					}
				}
				
				if (answer == null)
					delay(3000)
			}
			
			val json = Json.parseToJsonElement(answer).jsonObject
			val result = json["result"]!!.jsonObject
			val type = result["SCHEDULE_TYPE"].toString().replace("\"", "")
			
			val todayWorkingTime = if (type == "FIXED") {
				val shifts = result["SHIFTS"]!!.jsonArray
				val firstShift = shifts[0].jsonObject
				val startStr = firstShift["WORK_TIME_START"].toString().toIntOrNull()
				val endStr = firstShift["WORK_TIME_END"].toString().toIntOrNull()
				TimeInterval(if (startStr == null) null else startStr / 60, if (endStr == null) null else endStr / 60)
			}
			else {
				TimeInterval(null, null)
			}
			
			historyUnits += HistoryUnit(
				today,
				todayWorkingTime.from,
				todayWorkingTime.to,
				null,
				null,
				HistoryUnitMode.FIXED_WORKING_TIME
			)
		}
	}
	
	val result = if (historyUnits.isEmpty()) return historyUnits else historyUnits.sortedBy { it.fixedFrom }.sortedBy { it.date.dayOfMonth }
	
	return result
}


expect fun createScanner(): Scanner


fun er(userMessage: Any?, logMessage: Any? = null) {
	val message = userMessage ?: "Unknown error"
	
	println(message)
	
	errorMessage = message.toString()
	val uid = Random.nextInt()
	errorMessageId = uid
	
	launch {
		delay(15000)
		
		if (errorMessage != language.OFFLINE_ERROR && errorMessageId == uid)
			errorMessage = ""
		
		logError(logMessage ?: message)
	}
}


expect fun logError(message: Any)


suspend fun webHook(command: String, vararg params: Pair<String, Any?>) =
	httpClient.multiSendPostRequest(
		"${
			if (commonSettings.DEBUG_MODE)
			//"https://dev24.art-vending.online/rest/3/863crwql1l073ypq/"
			//"https://dev24.art-vending.online/rest/3/pd7awms6qnmnwz5g/"
				"https://dev24.art-vending.online/rest/3/69vhsg5g4podtfh0/"
			else
				"https://b24.art-vending.online/rest/3/863crwql1l073ypq/"
		}$command.json", *params
	)


fun LocalDate.getMonthFullNumber() = year * 12 + month.number - 1


fun showError(message: String, closeHandler: (() -> Unit)? = null) {
	showMessage(language.ERROR, message, closeHandler)
}


suspend fun showErrorAndWait(message: String) {
	showMessageAndWait(language.ERROR, message)
}


fun showMessage(title: String, text: String, closeHandler: (() -> Unit)? = null) {
	dialog.show(title, text, closeHandler)
}


suspend fun showMessageAndWait(title: String, text: String) {
	dialog.showAndWaitNotImplemented(title, text)
}


abstract class RequestAnswer


class Success : RequestAnswer()


abstract class Failure() : RequestAnswer()


class FailureFromServer(val errorTypeCode: String, val errorMessages: List<String>) : Failure() {
	override fun toString() = "$errorTypeCode:\n${errorMessages.joinToString("\n")}"
}


class FailureException(val errorMessage: String) : Failure() {
	override fun toString() = errorMessage
}


suspend fun sendScannerPostRequest(qrCode: String, geolocation: Point?): RequestAnswer {
	if (allowDevice != true)
		return FailureException("Not allowed!")
	
	try {
		
		///////////////////////////////////
//		if (commonSettings.DEBUG_MODE) {
//			delay(5000)
//			throw Exception("Aaa")
//		}
		///////////////////////////////////
		
		val currentDateTime = LocalDateTime.now()
		val instant = currentDateTime.toInstant(TimeZone.currentSystemDefault())
		//val time = (instant.toEpochMilliseconds() / 1000)
		
		val url = if (commonSettings.DEBUG_MODE)
			"https://dev24.art-vending.online/rest/3/pd7awms6qnmnwz5g/worktime.set"
		else
			"https://b24.art-vending.online/rest/3/pd7awms6qnmnwz5g/worktime.set"
		
		val urlWithParams = "$url?user_id=$userPikalkaId&qr_code=$qrCode&geolocation[latitude]=${geolocation?.x ?: ""}&geolocation[longitude]=${geolocation?.y ?: ""}&device_id=$deviceId"
		
		val answer = try {
			httpClient.multiSendGetRequest(urlWithParams)
		} catch (e: Exception) {
			if (isInternetAvailable())
				er("Send QR-code error!", e.message)
			else
				er(language.OFFLINE_ERROR)
			
			null
		}
		
		log("qrCode = $qrCode")
		log("response = $answer")
		
		if (answer == "" || answer == null)
			return FailureException(language.SERVICE_FAIL)
		else {
			
			val json = Json.parseToJsonElement(answer).jsonObject
			val result = json["result"]!!.jsonObject
			val isSuccess = result["isSuccess"].toString()
			
			return if (isSuccess == "true")
				Success()
			else
				FailureFromServer(result["error_type_code"].toString(), result["error"]!!.jsonArray.toList().map { it.toString() })
		}
	} catch (e: Exception) {
		if (isInternetAvailable())
			er(e.message)
		else
			er(language.OFFLINE_ERROR)
		
		return FailureException(language.UNKNOWN_ERROR)
	}
}


fun minutesToTimeString(minutes: Int?, withZeroInHours: Boolean = false) =
	if (minutes == null) "" else "${if (withZeroInHours) (minutes / 60).toString().padStart(2, '0') else (minutes / 60)}:${(minutes % 60).toString().padStart(2, '0')}"


fun humanizeUnit(value: Int, str: String, strSeveral: String, strMany: String): String {
	val value = abs(value)
	val lastDigit = value.toString().last().toString().toInt()
	return when {
		lastDigit == 0 || lastDigit >= 5 || (value >= 11 && value <= 14) -> strMany
		lastDigit == 1 -> str
		else -> strSeveral
	}
}


fun humanizeMinutes(minutes: Int): String {
	val hours = minutes / 60
	val remainingMinutes = minutes % 60
	
	return if (hours == 0)
		"$remainingMinutes ${humanizeUnit(remainingMinutes, language.MINUTE, language.MINUTES, language.MINUTES_2)}"
	else if (remainingMinutes == 0)
		"$hours ${humanizeUnit(hours, language.HOUR, language.HOURS, language.HOURS_2)}"
	else
		"$hours ${humanizeUnit(hours, language.HOUR, language.HOURS, language.HOURS_2)} $remainingMinutes ${humanizeUnit(remainingMinutes, language.MINUTE, language.MINUTES, language.MINUTES_2)}"
}


fun LocalDate.getDayOfWeekStr() = getDayOfWeekStr(dayOfWeek)


fun goHome() {
	currentScreenModel = HomeScreenModel()
}


fun LocalDate.toMyString() = "$dayOfMonth ${getMonthStr2(month.number)} $year ${getDayOfWeekStr()}"


fun getMonthStr(monthNumber: Int) = when (monthNumber) {
	1 -> language.JANUARY
	2 -> language.FEBRUARY
	3 -> language.MARCH
	4 -> language.APRIL
	5 -> language.MAY
	6 -> language.JUNE
	7 -> language.JULY
	8 -> language.AUGUST
	9 -> language.SEPTEMBER
	10 -> language.OCTOBER
	11 -> language.NOVEMBER
	12 -> language.DECEMBER
	else -> throw IllegalArgumentException("Invalid month")
}


expect fun millisecondsToDateTime(millis: Long): LocalDateTime


expect fun showLocationWarning()


expect fun userSetted()


fun LocalDateTime.toEpocTime(): Long {
	val instant = toInstant(TimeZone.currentSystemDefault())
	return (instant.toEpochMilliseconds())
}


expect fun isInternetAvailable(): Boolean


suspend fun <T> multiTry(tryCount: Int, pause: Long, block: suspend () -> T?): T? {
	var result: T? = null
	
	for (i in 0 until tryCount) {
		result = block()
		
		if (result != "" && result != null)
			break
		
		if (i < tryCount - 1)
			delay(pause)
	}
	
	return result
}